module.exports = __webpack_public_path__ + "static/media/9.eeffc1f8.jpg";